module.exports = __webpack_public_path__ + "img/4.f3e4169e.png";